import React from 'react';

const PdfDownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 9.91667V1.75" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M12.25 9.91699C12.25 11.2056 11.2052 12.2503 9.91667 12.2503H4.08333C2.79475 12.2503 1.75 11.2056 1.75 9.91699"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91595 7L6.9987 9.91725L4.08203 7"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PdfDownloadIcon;
